export default __webpack_public_path__ + "static/media/a10.935be7ef.png";